import { render } from "./IndustryArea.vue?vue&type=template&id=106def02&scoped=true"
import script from "./IndustryArea.vue?vue&type=script&lang=js"
export * from "./IndustryArea.vue?vue&type=script&lang=js"

import "./IndustryArea.vue?vue&type=style&index=0&id=106def02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106def02"]])

export default __exports__